export enum PostCategoryItemType {
  Link,
  Registration = 2,
  AnotherTime,
  NotInterested,
  ChooseOption,
  StillCanJoin,
  NoOptionWorks,
  FullyBooked,
  IAmParticipant,
  NotPossibleToParticipate,
}

export enum PostCategoryType {
  Invite,
  Reminder,
  Confirmation,
  ChangeOfPlanning,
  Cancellation,
  InviteReminder,
}

export enum PostActivityType {
  PostRead = 0,
  PostClick = 1,
  ButtonClick = 2,
  PlayButtonClick = 3,
  UrlClick = 4,
  OpenAttachment = 5,
  CollapseText = 6,
}
